import { tryList } from "./_shared";

export interface AdHocUsageItem {
  description: string | null;
  unit_price: number | null;
  invoice_date: string | null;
  vendor_name: string;
}

export interface TopAdHocItem {
  description: string | null;
  unit_price: number | null;
  vendor_name: string;
}

export const dashboardService = {
  getAdHocUsageByVendor(_companyId: string) {
    return tryList<AdHocUsageItem>("/api/dashboard/ad-hoc-usage-by-vendor");
  },
  getTopAdHocItems(_companyId: string) {
    return tryList<TopAdHocItem>("/api/dashboard/top-ad-hoc-items");
  },
};
